module.exports = __webpack_public_path__ + "static/flor-f4555a40aed79499d855b6fc8173256d.png";